import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { gamesApi } from "../services/api";

const GamesCatalogContext = createContext(null);

export function GamesCatalogProvider({ children }) {
  const [catalog, setCatalog] = useState({
    providers: [],
    source: "boot",
    warning: "",
    loading: true,
    ready: false,
  });

  const load = (force = false) => {
    setCatalog((prev) => ({ ...prev, loading: !prev.ready }));
    return gamesApi
      .providers(force ? { refresh: "1" } : {})
      .then((data) => {
        setCatalog({
          providers: data.providers || [],
          source: data.source || "api",
          warning: data.warning || "",
          loading: false,
          ready: true,
        });
      })
      .catch((err) => {
        setCatalog((prev) => ({
          ...prev,
          warning: err.message,
          loading: false,
          ready: true,
        }));
      });
  };

  useEffect(() => {
    // Pages like crypto or sports never read the catalog, let their own data land first.
    const heavy = /^\/(oyun\/kripto|kripto|spor|iddaa|espor)/.test(window.location.pathname);
    if (!heavy) {
      load(false);
      return undefined;
    }
    const idle = window.requestIdleCallback
      ? window.requestIdleCallback(() => load(false), { timeout: 3000 })
      : setTimeout(() => load(false), 1200);
    return () => {
      if (window.cancelIdleCallback) window.cancelIdleCallback(idle);
      else clearTimeout(idle);
    };
  }, []);

  const value = useMemo(
    () => ({
      ...catalog,
      reload: () => load(true),
    }),
    [catalog]
  );

  return <GamesCatalogContext.Provider value={value}>{children}</GamesCatalogContext.Provider>;
}

export function useGamesCatalog() {
  const ctx = useContext(GamesCatalogContext);
  if (!ctx) throw new Error("useGamesCatalog provider gerekli");
  return ctx;
}
